<template>
  <div v-if="stats" v-cloak>
    <div v-if="idxPatient">
      <div class="container bg--gen-negative">
        <div class="flex-wrapper">
          <h5 class="text-muted margin-left-vw">Index-ID: {{ idxPatient.indexPatientId }}</h5>
          <small>
          <router-link class="text-muted edit-link" :to="{ name: 'editidxpatient', params: { id: idxPatient.indexPatientId }}">
            ✏️ Redigera
          </router-link>
          </small>
        </div>
        <h1 class="text-muted margin-left-vw">{{ idxPatient.firstName + ' ' + idxPatient.lastName }}</h1>
        <p>
          <span class="text-muted margin-left-vw" v-text="idxPatSsn(idxPatient.ssn)"></span>
          <span class="text-muted">({{ getAge }} år)</span>
        </p>
        <p class="text-muted margin-left-vw">
          <strong>Registrerad av:</strong>
          {{ idxPatient.clinicianName }}
          <br />
          <strong>Patientflöde</strong>:
          {{ ($options.name && $options.name.includes('negative') ? 'Gen negativ' : 'Gen positiv') }}
        </p>
        <div class="row row-cols-2 pull-right">
        <div class="col">
          <strong>Folkbokförd</strong>
          <p v-if="populationInfo">
            {{ populationInfo.streetAddress || '-' }} <br />
            {{ populationInfo.postalCode || '-' }} <br />
            {{ populationInfo.city || '-' }}
          </p>
          <div v-if="!populationInfo" class="div-loader">Hämtar</div>
        </div>
          <vc-donut :size="150" :thickness="30" class="top-right vc--donut" :sections="nmbrOfInvited">
            <strong>Antal släktingar inmatade i släktträdet <br /> {{ totalInvited }}</strong>
          </vc-donut>
          <div class="col">
            <strong>Inbjudna släktingar</strong>
            <span class="filter cursor-pointer" v-popover:tooltip.left="infoRelatives">
              <img src="@/assets/img/i-icon.svg?data" alt="En infoikon" class="img-fluid" />
            </span>
            <br>
            {{ stats.numFHRejected }} <span class="_square green"></span> Diagnos ej FH<br>
            {{ stats.numFHConfirmed }} <span class="_square pink"></span> Diagnos FH<br>
            {{ stats.numInProgress }} <span class="_square blue"></span> Pågående<br>
            {{ stats.numAwaitingAnswer }} <span class="_square orange"></span> Väntar svar på inbjudan<br>
            {{ stats.numAwaitingAnswerMoreThan90Days }} <span class="_square violet"></span> Ej svarat > 3 mån<br>
            {{ stats.numDeclined }} <span class="_square black"></span> Avböjt<br>
          </div>
          <div class="col minus-margin">
            <div class="clearfix"></div>
            <strong>Kontakt</strong><br>
            <i v-if="idxPatient.phoneNumber !== null && !idxPatient.phoneNumber.startsWith('0')">+46</i>
            <span v-if="idxPatient.phoneNumber">{{ idxPatient.phoneNumber }}<br></span>
            <span v-if="idxPatient.emailAddress">{{ idxPatient.emailAddress }}<br></span>
          </div>
          <div class="col">
          </div>
        </div>
        <div class="row">
          <div class="col col-lg-10">
            <strong>Mutation</strong>
            <p>{{ idxPatient.mutation || '-' }}</p>
          </div>
          <div class="col-lg-10">
            <strong>Långt mutationsnamn</strong>
            <p>{{ idxPatient.mutationLong || '-' }}</p>
          </div>
          <div class="col-lg-3">
            <strong>Status</strong>
            <p>{{ getStatus(idxPatientStatus) || '-' }}</p>
          </div>
          <div class="col-lg-4">
            <strong>Diagnosställe</strong>
            <p>{{ idxPatient.diagnosisLocation || '-' }}</p>
          </div>
          <div class="col-lg-3">
            <strong>Diagnosdatum</strong>
            <p v-if="idxPatient && !idxPatient.diagnosisDate">-</p>
            <p v-if="idxPatient && idxPatient.diagnosisDate">
              {{ new Date(idxPatient.diagnosisDate).toLocaleDateString() || '-' }}
            </p>
          </div>
        </div>
        <table class="table table-bordered bg-light table-margin">
          <thead>
            <tr>
              <th scope="col">Högst journalförda LDL värde</th>
              <th scope="col">Enhet</th>
              <th scope="col">Referensintervall</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ idxPatient.ldl || '-' }}</td>
              <td>{{ idxPatient.ldlUnit || '-' }}</td>
              <td>{{ idxPatient.ldlReferenceInterval || '-' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="row row-margin">
          <div class="col-lg-3 vertical-border-left">
            <strong>Dutch Lipid Score</strong>
            <p v-if="idxPatient.highestDLCN === null">-</p>
            <p>{{ idxPatient.highestDLCN }}</p>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="card btn-card">
          <div class="card-body">
            <p class="text-dark pull-left"><strong>Manuella förfaranden</strong></p>
            <div class="row">
              <div class="col-lg-4">
                <label class="card-label">
                  Registrering av minderåriga barn färdigt (försvinner från <router-link to="/todo_gen_negative">Att göra</router-link>)
                  &nbsp;
                  <input type="checkbox" @change="sendMinorChildrenRegistrationComplete()" v-model="childrenUnder13Registered">
                </label>
              </div>
              <div class="col-lg-3"></div>
              <div class="col-lg-3"></div>
              <div class="col-lg-2"></div>
            </div>
          </div>
        </div>
        <div class="alert alert-success alert-registration">
          <strong>Nu är ditt val utfört kring registrering av minderåriga barn.</strong>
        </div>
        <nav class="navbar navbar-expand-sm bg-light">
          <!-- Links -->
          <ul class="navbar-nav">
            <li class="nav-item active_btm">
              <a class="nav-link text-primary" href="#">Inbjudna</a>
            </li>
            <li class="nav-item right">
              <span class="_square familytree-row-1"
                v-tooltip.left="'Färg indikerar: Mamma, pappa, mor- och farföräldrar'"></span>
                &nbsp;
              <span class="_square familytree-row-7"
                v-tooltip.left="'Färg indikerar: Barn och barnbarn'"></span>
                &nbsp;
              <span class="_square familytree-row-9"
                v-tooltip.left="'Färg indikerar: Syskon och syskonbarn'"></span>
                &nbsp;
              <span class="_square familytree-row-11"
                v-tooltip.left="'Färg indikerar: Mammas respektive pappas halvsyskon samt deras barn'"></span>
                &nbsp;
              <span class="_square familytree-row-15"
                v-tooltip.left="'Färg indikerar: Mammas respektive pappas syskon samt deras barn (kusiner)'"></span>
                &nbsp;
            </li>
          </ul>
        </nav>
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th scope="col">Pat#</th>
                <th scope="col">PNR</th>
                <th scope="col">Relation</th>
                <th scope="col">Tillhör</th>
                <th scope="col">Efternamn</th>
                <th scope="col">Förnamn</th>
                <th scope="col">Mutation</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody v-if="familytree.length === 0">
              <div class="clearfix"></div>
              <tr>
                ▶ Denna indexpatient har för närvarande inga inbjudna släktingar som loggat in i FHabian ännu
              </tr>
            </tbody>
            <tbody v-if="familytree.length !== 0">
              <tr v-for="(f, i) in familytree" :key="i" :class="'familytree-row-' + f.familyRelation">
                <th scope="row">
                  <router-link :to="{ name: 'patient_gen_negative', params: { id: f.personId }}">
                    {{ f.personId }}
                  </router-link>
                </th>
                <td>
                  <details>
                    <summary>Personnummer</summary>
                    {{ idxPatSsn(f.ssn) }}
                  </details>
                </td>
                <td>{{ kinshipType(f.familyRelation) || '-' }}
                  <strong v-if="kinshipType(f.familyRelation) === 'Barn' && isMinorChild(f.personId)">
                    (Minderårigt barn)
                  </strong>
                </td>
                <td>{{ getNameByNode(f.familyTreeParentNode) || '-' }}</td>
                <td>{{ f.lastName || '-' }}</td>
                <td>{{ f.firstName || '-' }}</td>
                <td>{{ f.mutation || '-' }}</td>
                <td>{{ screeningStatus(f.screeningStatus) || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { getKinshipType } from '../plugins/relationhandler'
import { getScreeningStatus } from '../plugins/screening_status'
import { getIdxStatus } from '../plugins/status_idx'
import { request } from '../plugins/datocms'
import $ from 'jquery'

export default {
  name: 'indexpatient_gen_negative',
  components: {
  },
  props: ['id'],
  data () {
    return {
      idxPatient: null,
      idxPatientStatus: null,
      stats: null,
      totalInvited: null,
      populationInfo: null,
      childrenUnder13Registered: null,
      infoRelatives: 'Nedan visas data utifrån inbjudna släktingar så ' +
      'det kan förekomma skillnad i datat ovan som visar släktingar oavsett inbjuden eller ej',
      familytree: [],
      childrenUnder13: []
    }
  },
  methods: {
    toElementTitle (str) {
      if (str) {
        let res = $('<textarea />').html(str).text() // convert special html entity chars
        res = res.replace(/<[^>]*>?/gm, '') // strip html tags
        return res
      }
    },
    kinshipType (famRel) {
      if (famRel) {
        const result = getKinshipType(famRel)
        return result
      }
    },
    screeningStatus (scrStat) {
      if (scrStat) {
        const result = getScreeningStatus(scrStat)
        return result
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    idxPatSsn (ssn) {
      if (ssn) {
        const output = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return output
      }
      return '-'
    },
    sendMinorChildrenRegistrationComplete () {
      const r = confirm('Är du säker på att ditt beslut?')
      if (r) {
        let loader = this.$loading.show()
        axios.postChildrenUnder13AllChildrenRegistered(config.childrenUnder13Uri + config.allChildrenRegUri,
          this.idxPatient.personId, this.childrenUnder13Registered).then(response => {
          if (response) {
            loader.hide()
            $('.alert-registration').show().delay(4000).fadeOut()
            setTimeout(() => {
              location.reload()
            }, 2000)
          }
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not send genetictest: ' + error)
            loader.hide()
          }
        })
      }
    },
    getNameByNode (node) {
      if (node) {
        const relative = this.familytree.find(x => x.familyTreeNode === node)
        if (relative) {
          return relative.firstName + ' ' + relative.lastName
        }
        return ''
      }
    },
    getStatus (status) {
      return getIdxStatus(status)
    },
    getIdxPatientAndFamilytree () {
      let loader = this.$loading.show()
      const url = config.indexPatientUri + '/byId?indexPatientId=' + this.id
      axios._get(url).then(response => {
        this.idxPatient = response.data.indexPatient
        if (this.idxPatient) {
          if (this.idxPatient.highestLDL) {
            const parsedLDL = JSON.parse(this.idxPatient.highestLDL)
            this.idxPatient.ldl = parsedLDL.ldl
            this.idxPatient.ldlUnit = parsedLDL.ldlUnit
            this.idxPatient.ldlReferenceInterval = parsedLDL.ldlReferenceInterval
          } else {
            this.idxPatient.ldl = ''
            this.idxPatient.ldlUnit = ''
            this.idxPatient.ldlReferenceInterval = ''
          }

          this.getIdxPatientAllChildrenRegistered(this.idxPatient.personId)
          this.getFromNavet()

          const familytreeUrl = config.familytreeUri + '?IndexPatientId=' + this.idxPatient.indexPatientId
          axios._get(familytreeUrl).then(response => {
            this.familytree = response.data.familyMembers
            if (this.familytree.length > 0) {
              this.familytree.sort((a, b) => parseFloat(a.familyRelation) - parseFloat(b.familyRelation))
            }
            loader.hide()
          }).catch((error) => {
            if (error.response && error.response.status === 401) {
              window.location.href = window.location.origin.concat('/error')
            } else {
              console.log('Could not get familytree: ' + error)
              loader.hide()
            }
          })
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get indexpatients: ' + error)
          loader.hide()
        }
      })
    },
    async getFamilytreeStats () {
      axios._get(config.familytreeUri + '/stat?IndexPatientId=' + this.id).then(response => {
        this.stats = response.data.familyTreeStatistics
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get number of invited: ' + error)
        }
      })
    },
    getFromNavet () {
      if (this.idxPatient) {
        axios.postPopulationRegistry(config.populationRegistryUri, this.idxPatient.ssn).then((response) => {
          if (response) {
            this.populationInfo = response.data
            if (this.populationInfo) {
              this.hasPopulationInfo = true
            }
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log(error)
          }
        })
      }
    },
    getNumberOfInvitedAndStatus () {
      axios._get(config.indexPatientUri + config.allUri).then(response => {
        this.totalInvited = response.data.indexPatients.find(i => i.indexPatientId === parseInt(this.$props.id)).numberOfInvited
        this.idxPatientStatus = response.data.indexPatients.find(i => i.indexPatientId === parseInt(this.$props.id)).status
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get indexpatients: ' + error)
        }
      })
    },
    getChildrenUnder13All () {
      axios._get(config.childrenUnder13Uri + config.allUri + '?IndexPatientId=' + parseInt(this.$props.id)).then(response => {
        this.childrenUnder13 = response.data.childrenUnder13
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get children under 13: ' + error)
        }
      })
    },
    getIdxPatientAllChildrenRegistered (personId) {
      if (personId) {
        axios._get(config.childrenUnder13Uri + config.allChildrenRegUri + '?PersonId=' + personId).then(response => {
          this.childrenUnder13Registered = response.data.allChildrenRegistered
        }).catch((error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log('Could not get all children registered for indexpatient: ' + error)
          }
        })
      }
    },
    isMinorChild (personId) {
      let isMinor = false
      this.childrenUnder13.forEach(child => {
        if (child.personId === personId) {
          isMinor = true
        }
      })
      return isMinor
    }
  },
  computed: {
    nmbrOfInvited () {
      const tot = parseInt(this.totalInvited)
      return [{ value: tot }]
    },
    getAge () {
      const d = this.idxPatient.ssn.substring(0, 8)
      var birthday = +new Date(d.substr(0, 4), d.substr(4, 2) - 1, d.substr(6, 2))
      return ~~((Date.now() - birthday) / (31557600000))
    }
  },
  async beforeMount () {
    await this.getFamilytreeStats()
    this.getIdxPatientAndFamilytree()
    this.getNumberOfInvitedAndStatus()
    this.getChildrenUnder13All()
  },
  async mounted () {
    this.intervalLists = await request({
      query: `
        {
          clinicMisc {
            ldlRefList
          }
        }
      `
    })
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.includes('/patient_gen_negative/') || to.path.includes('/editidx/')) {
      next()
    } else {
      const parts = to.path.split('/')
      const uri = '/' + parts[parts.length - 1]
      window.location.href = window.location.origin + uri
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
input[type=checkbox] {
  cursor: pointer;
  vertical-align: middle;
  transform: scale(1.5);
}
input[type=text]:disabled {
  opacity: 0.6;
}
._square {
  height: 10px;
  width: 10px;
  display: inline-block;
}
.green {
  background: #d7e7c5;
}
.pink {
  background: #f8b5be;
}
.blue {
  background: #61c4e3;
}
.orange {
  background: #ff8856;
}
.violet {
  background: #a57c7c;
}
.black {
  background: #514f4e;
}
.btn-card:hover {
  background: #e0e4e7;
  border: 1px solid #d4d8db;
  color: #000;
  opacity: 1.0;
}
.btn-card {
  margin: 30px 0 20px 0;
  background: #e9ecef;
  border: 1px solid #dee2e6;
  color: #38362E;
  opacity: 0.8;
}
.familytree-row-1, .familytree-row-2, .familytree-row-3,
.familytree-row-4, .familytree-row-5, .familytree-row-6 {
  background: #5cb85cb6;
  color: #000;
}
.familytree-row-7, .familytree-row-8 {
  background: #4f9e4faf;
  color: #000;
}
.familytree-row-9, .familytree-row-10 {
  background: #5bc0deb6;
  color: #000;
}
.familytree-row-11, .familytree-row-12,
.familytree-row-13, .familytree-row-14 {
  background: #4ea3bdb2;
  color: #000;
}
.familytree-row-15, .familytree-row-16,
.familytree-row-17, .familytree-row-18 {
  background: #336b7bc0;
  color: #fff;
}
.pull-right {
  float: right !important;
}
.right {
  position: absolute;
  top: 1.5rem;
  right: 0;
}
.top-right {
  position: absolute;
  top: 0px;
  right: 0px;
  margin-top: 5.5em;
  margin-right: 1.1em;
}
.vertical-border-left {
  border-left: 6px solid #069ccc;
}
.table-margin {
  margin-top: 1vh;
  margin-left: 10px;
  max-width: 80vw;
}
.row-margin {
  margin-left: 0px;
}
.minus-margin {
  margin-top: -65px;
}
.edit-link {
  vertical-align: middle;
  text-decoration: none;
  margin-left: 1em;
}
.card-label {
  font-size: 13px;
}
.container > * {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/IndexPatientGenNegative.vue